import { render } from "./AppDetails.vue?vue&type=template&id=2aade096&lang=true"
import script from "./AppDetails.vue?vue&type=script&lang=js"
export * from "./AppDetails.vue?vue&type=script&lang=js"

import "./AppDetails.vue?vue&type=style&index=0&id=2aade096&scope=true&lang=css"
script.render = render

export default script